import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'item-summary',
    loadChildren: () => import('./pages/item-summary/item-summary.module').then(m => m.ItemSummaryPageModule),
  },
  {
    path: 'walkthrough',
    loadChildren: () => import('./pages/walkthrough/walkthrough.module').then(m => m.WalkthroughPageModule),
  },
  { path: 'login', loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule) },
  { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule) },
  {
    path: 'printer-setup',
    loadChildren: () => import('./pages/printer-setup/printer-setup.module').then(m => m.PrinterSetupPageModule),
  },
  { path: 'pin', loadChildren: () => import('./pages/pin/pin.module').then(m => m.PinPageModule) },
  { path: 'docket', loadChildren: () => import('./pages/docket/docket.module').then(m => m.DocketPageModule) },
  {
    path: 'vip-settings',
    loadChildren: () => import('./pages/vip-settings/vip-settings.module').then(m => m.VipSettingsPageModule),
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'ignore',
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
